import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initBrandsFilter = function() {
  const sliderBrandsFilter = document.querySelectorAll('[data-slider-catalog-brands]');

  if (sliderBrandsFilter.length > 0) {
    sliderBrandsFilter.forEach(brand => {
      // const swiperBrandsFilter = function() {
      new Swiper(brand, {
          spaceBetween: 10,
          slidesPerView: 2,
          breakpoints: {
            768: {
              slidesPerView: 7,
              spaceBetween: 6
            },
            1500: {
              slidesPerView: 7,
              spaceBetween: 36
            }
          }
        }
      );
      // }
      // swiperBrandsFilter();
    })
  }
};
